module.exports = __webpack_public_path__ + "img/card_home1.94c84bf4.svg";